module.exports = __webpack_public_path__ + "077c6d420b3579a9e2cecbb098a95e00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_bg01.jpg
// module id = 204
// module chunks = 1